import delegate from 'delegate'

export default function () {
  delegate('a[href^="#"]', 'click', e => {
    e.preventDefault()
    const $section = document.querySelector(e.target.hash)
    if ($section) {
      window.scroll({
        top: $section.offsetTop,
        behavior: 'smooth'
      })
    }
  }, false)
}